import LoadingDots from '@/components/ui/loading-dots';
import { useQuoteSummaryMutationState } from '@/services/hooks/useQuoteSummaryMutationState';

const TotalMinCost = () => {
  const { isMutating, data } = useQuoteSummaryMutationState();

  const totalMinimum = data?.summary?.totalMinimum;

  return (
    <div className="text-base md:text-lg font-nunito700 flex justify-between border-t-2 border-grey-50 pt-4 lg:pt-6 mb-6 lg:mb-8">
      <span>Total min cost</span>{' '}
      <span>
        {isMutating ? <LoadingDots variant="primary" /> : <>${totalMinimum}</>}
      </span>
    </div>
  );
};

export { TotalMinCost };
